import { useSyncExternalStore } from "react";
import { outboxSnapshot, subscribeToOutbox } from "./outbox";
import type { OutboxSnapshot } from "./types";

export function useOutbox(): OutboxSnapshot {
  return useSyncExternalStore(subscribeToOutbox, outboxSnapshot, outboxSnapshot);
}
